/*
 * Shared by the card-save and top-up flows, which is why it is not a private
 * helper of either. Both were in one 920-line file, so the sharing was
 * invisible; splitting that file is what surfaced it.
 */

// Poll `fn` until `satisfied` or attempts run out. Card save and top-up crediting
// are webhook-driven on the billing side, so the fresh value can lag the Stripe
// confirmation by a beat. Crash-safe: a transient read failure (network blip while
// polling) is swallowed and retried — the Stripe side already succeeded, so we must
// not turn a slow webhook into a scary error. Returns the last value seen, or
// undefined if every attempt threw.
export async function poll<T>(
  fn: () => Promise<T>,
  satisfied: (value: T | undefined) => boolean,
  attempts = 5,
  delayMs = 800,
): Promise<T | undefined> {
  let value: T | undefined;
  for (let i = 0; i < attempts; i++) {
    if (i > 0) await new Promise((resolve) => setTimeout(resolve, delayMs));
    try {
      value = await fn();
    } catch {
      continue; // transient — keep polling
    }
    if (satisfied(value)) return value;
  }
  return value;
}
